import { B400, N0, N40, N50, N100, N200 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import styled, { css } from 'styled-components';

import { ColumnCss } from '../../../styles';

type DummySpaceReducerProps = {
    bottomMargin: string;
};

export const FlexRowAlignedCentered = css`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const ItemWrapper = styled.div`
    ${ColumnCss};
    border: 2px solid ${token('elevation.surface.overlay.pressed', N40)};
    background-color: ${token('elevation.surface.raised')};
    border-radius: 4px;
    margin-bottom: 4px;
    cursor: move;
    padding: 4px;

    img.handler-icon {
        margin-right: 8px;
    }
`;

export const OptionsWrapper = styled.div`
    ${FlexRowAlignedCentered};
    padding: 8px;
`;

export const ItemExtraOptionsWrapper = styled.div`
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const ExtraOption = styled.div`
    cursor: pointer;
    &.text-option {
        margin-right: 24px;
        color: ${token('color.text.accent.blue', B400)};
        padding: 1px;
    }
    display: flex;
    align-items: center;
`;

export const ItemNameWrapper = styled.div`
    ${FlexRowAlignedCentered};
    width: 90%;

    div[data-testid='option-input-container'] {
        border: none;
        background: none;

        input {
            width: 98.6%;
        }
    }
`;

export const ItemDefaultOption = styled.div`
    color: ${token('color.text.subtlest', N100)};
    font-style: italic;
`;

export const AddOptionButton = styled.div`
    border-radius: 4px;
    color: ${token('color.text.accent.blue', B400)};
    cursor: pointer;
    background: ${token('color.background.accent.blue.subtler', '#DEEAFF')};
    padding: 16px;
    margin-top: 4px;
    height: 24px;
`;

export const AddOptionButtonItemsWrapper = styled.div`
    ${FlexRowAlignedCentered};
    width: inherit;
    justify-content: center;
`;

export const AddOptionText = styled.div`
    color: ${token('color.text.accent.blue', B400)};
    margin-left: 16px;
`;

export const AddOptionInfoFrame = styled.div`
    margin-bottom: 4px;
    background: ${token('color.background.input', N0)};
    border: 1px dashed ${token('color.border.accent.gray', N50)};
    border-radius: 3px;
    color: ${token('color.text.subtlest', N200)};
    padding: 18px 0;
    text-align: center;
`;

export const ActionsBar = styled.div`
    ${FlexRowAlignedCentered};
    justify-content: space-between;
    margin: 12px;
    margin-left: 4px;
    margin-right: 16px;
`;

export const ActionItem = styled.div`
    cursor: pointer;
    color: ${token('color.text', '#000')} img {
        cursor: pointer;
    }
`;

export const RightSide = styled.div`
    display: flex;
    align-items: center;

    .text-option {
        margin-right: 0;
    }
`;

export const OptionIdWrapper = styled.div`
    ${FlexRowAlignedCentered};
    margin-top: 16px;

    .copy-icon {
        margin-left: 8px;
        cursor: pointer;
    }
`;

export const OptionIdText = styled.div`
    font-size: 12px;
    color: ${token('color.text.subtle', N200)};
`;

export const TabsWrapper = styled.div`
    padding-left: 20px;
`;

export const TabWrapper = styled.div`
    ${ColumnCss};
    margin-top: 16px;

    label {
        margin-left: -6px;
    }
`;

export const RemoveOption = styled.div`
    text-align: right;
    margin-bottom: 16px;
    margin-right: 44px;
`;

export const TranslationsWrapper = styled.div`
    ${ColumnCss};
    margin-top: 8px;
    width: 100%;
`;

export const TranslationFormWrapper = styled.div`
    ${FlexRowAlignedCentered};
    margin-top: 8px;
    margin-bottom: 4px;
    width: 85%;

    div[id^='translations-'],
    div[data-testid^='translations-'] {
        width: 50%;
    }
    div[data-testid^='translations-input'] {
        margin-left: 8px;
        flex: 1 !important;
    }
`;

export const TranslationsLanguageLabelWrapper = styled.div`
    display: flex;
    align-items: center;

    img {
        width: 16px;
        height: 16px;
    }

    span.label {
        padding-left: 8px !important;
        padding-bottom: 0 !important;
    }
`;

export const DummySpaceReducer = styled.div<DummySpaceReducerProps>`
    margin-bottom: ${props => props.bottomMargin};
`;
